import { createSlice } from '@reduxjs/toolkit'

export const flySearchResponseData = createSlice({
  name: 'flySearchResponseData',
  initialState: {},
  reducers: {
    setFlySearchResponseData: (state, action) => {
      return action.payload
    },
  },
})

export const { setFlySearchResponseData } = flySearchResponseData.actions
